import React, { useState } from 'react';
import { reduxForm } from 'redux-form';
import { partial } from '../../../util/translation/translation';
import InfoBox from '../../../shared/components/custom/InfoBox';
import PersonCardForm from './PersonCardForm';
import CompanyCardForm from './CompanyCardForm';
import GuestCardForm from './GuestCardForm';
import EmailInviteModal from './EmailInviteModal';

// A participant being edited is one of COMPANY, USER, or GUEST (see
// participant.type in EventsParticipantForm) - this maps that type to the
// form that owns editing it.
const TYPE_BY_PARTICIPANT = {
  COMPANY: 'company',
  USER: 'user',
  GUEST: 'guest',
};

const InviteParticipantsModal = ({
  companies,
  handleSubmit,
  currentParticipant,
  participantType,
  event,
  setMaxGuestAmount,
  maxGuestAmount,
  hasCompanyAccess,
}) => {
  const s = partial('shared');
  const p = partial('EventParticipantsPage');

  const editType = currentParticipant
    ? TYPE_BY_PARTICIPANT[currentParticipant.type]
    : null;
  const types = [
    { key: 'user', label: s('user') },
    { key: 'guest', label: s('guest') },
    { key: 'email', label: s('email') },
    ...(hasCompanyAccess ? [{ key: 'company', label: s('company') }] : []),
  ];
  const [type, setType] = useState(
    editType ??
      (participantType === 'company' && hasCompanyAccess ? 'company' : 'user')
  );

  const hints = {
    user: <p className="invite-modal__hint">{p('typeUserHint')}</p>,
    company: <p className="invite-modal__hint">{p('typeCompanyHint')}</p>,
    guest: <InfoBox>{p('guetsMessageInformation')}</InfoBox>,
    email: (
      <InfoBox>
        {p('guetsEmailMessageInformation')} {p('guetsMessageInformation')}
      </InfoBox>
    ),
  };

  return (
    <div className="invite-modal">
      {/* Editing is locked to the participant's own type, so the switch is
          only offered when inviting someone new. */}
      {!editType && (
        <div className="form-card__switch invite-modal__switch">
          {types.map(({ key, label }) => (
            <button
              key={key}
              type="button"
              className={`form-card__switch-btn${
                type === key ? ' active' : ''
              }`}
              onClick={() => setType(key)}
            >
              {label}
            </button>
          ))}
        </div>
      )}
      {hints[type]}
      {type === 'user' && (
        <PersonCardForm
          onSubmit={handleSubmit}
          participant={editType === 'user' ? currentParticipant : null}
          event={event}
          maxGuestAmount={maxGuestAmount}
          setMaxGuestAmount={setMaxGuestAmount}
        />
      )}
      {type === 'guest' && (
        <GuestCardForm
          onSubmit={handleSubmit}
          event={event}
          participant={editType === 'guest' ? currentParticipant : null}
          maxGuestAmount={maxGuestAmount}
        />
      )}
      {type === 'email' && <EmailInviteModal event={event} />}
      {type === 'company' && (
        <CompanyCardForm
          companies={companies}
          onSubmit={handleSubmit}
          participant={editType === 'company' ? currentParticipant : null}
        />
      )}
    </div>
  );
};

const reduxF = reduxForm({
  form: 'InviteParticipantsCard',
  enableReinitialize: true,
});

export default reduxF(InviteParticipantsModal);
